import React from "react";

export default function EmailSentPrompt({ title, prompt }) {
  return (
    <div
      className="flex flex-col items-start justify-center p-3 rounded-xl shadow-sm bg-green-100
    w-full sm:w-4/5
    my-3
    "
    >
      {/* Use the title prop */}
      <div className=" text-lg font-semibold">{title}</div>

      {/* Use the prompt prop */}
      <div className="text-base mt-3">{prompt}</div>
    </div>
  );
}
